import AccessControlDialog from "@/components/call/access-controls/shared/dialog";
import { AccessControlOpenGate } from "@EspaceParkQC/sdk-call-center";
import { toast } from "@EspaceParkQC/sdk-react";
import { Unlock } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function OpenGate() {
  const { t } = useTranslation("main");

  function handleSubmit() {
    toast.loading(t("intercom.access-controls.open-gate.submitting"));
  }

  function handleSuccess() {
    toast.success(t("intercom.access-controls.open-gate.success"));
  }

  function handleError(error: unknown) {
    if (error instanceof Error) {
      toast.error(error.message);
    } else {
      toast.error(JSON.stringify(error));
    }
  }

  return (
    <AccessControlOpenGate
      onGateError={handleError}
      onGateSuccess={handleSuccess}
      render={({ button, form }) => (
        <AccessControlDialog
          title={t("intercom.access-controls.open-gate.title")}
          description={t("intercom.access-controls.open-gate.description")}
          icon={<Unlock className="size-4" />}
          buttonProps={button}
          formProps={form}
          onSubmit={async () => handleSubmit()}
          formOnSubmit={async (value?: string | number) => {
            if (typeof value === "string") {
              await form.onSubmit(value);
            }
          }}
        />
      )}
    />
  );
}
